import { createSelector } from '@reduxjs/toolkit';
import LocationAPI from '../LocationAPI';
import { RootState } from '../../../redux/store.model';

// Pattern: createApiSelector
const getLocationsSelector = createSelector(
  (arg: string | undefined) => arg,
  (workspaceId) => LocationAPI.endpoints.getLocations.select(workspaceId)
);

export const getLocationsSelectorArgs = (
  state: RootState,
  args: { workspaceId: string | undefined }
) => getLocationsSelector(args.workspaceId)(state);

export const getRegionSelector = createSelector(
  [
    getLocationsSelectorArgs,
    (state, props: { groupId?: string }) => props.groupId,
  ],
  (locations, groupId) =>
    locations.data?.regions.find((region) => region.groupId === groupId)
);

export const getAllRegionsSelector = createSelector(
  [getLocationsSelectorArgs],
  (locations) => {
    return { regions: locations.data?.regions, isLoading: locations.isLoading };
  }
);
